module.exports = __webpack_public_path__ + "static/media/arrow-right.6608da53.svg";